<template>
  <v-card class="mt-3 pa-3" style="margin: 15px">
    <form @submit.prevent="gerarRelatorio">
      <div>
        <Select label="Ano" :options="optionsAno" v-model.number="aaletivo" :v="$v.aaletivo" :disabled="loading"/>
      </div>

      <div style="text-align: right">
        <v-btn width="120px" class="rounded-sm font-weight-regular" type="submit" color="teal" style="color:white" :disabled="loading" :loading="loadingGerar">
          <v-icon size="23" left dark>picture_as_pdf</v-icon>
          Gerar
        </v-btn>
      </div>
    </form>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import aulasMinistradasExigidasReport from '@/reports/professor/aulasMinistradasExigidasReport';
import { lessThen } from '../validations';

const TurmasRepository = RepositoryFactory.get('turma');
const DisciplinaRepository = RepositoryFactory.get('disciplina');
const ProfessorReportsRepository = RepositoryFactory.get('professorReports');
const AuthRepository = RepositoryFactory.get('auth');

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const defaultSelect = () => ({
  text: '',
  value: '',
});

export default {
  name: 'AulasMinistradasExigidas',
  data() {
    return {
      aaletivo: '',
      cdpessoal: '',
      cdmatric: '',
      cdtipesc: '',
      cdescola: '',
      loading: false,
      loadingGerar: false,
    };
  },
  validations() {
    return {
      aaletivo: { required },
      cdtipesc: { required },
      cdescola: { required },
      cdpessoal: { required },
      cdmatric: { required },

    };
  },
  async created() {
    this.aaletivo = this.getAnoAtualServidor;
    this.cdtipesc = this.school.cdtipesc;
    this.cdescola = this.school.cdescola;
    this.cdpessoal = this.userProfessor.cdpessoal;
    this.cdmatric = this.userProfessor.cdmatric;

    await this.loadTurma();
  },
  methods: {
    async loadTurma() {
      if(this.aaletivo === '') { return ; }
      try{
        this.loading = true;
        const { data } = await TurmasRepository.getSelectTurmasPerfil({
          ...this.userProfessor,
          ...this.school,
          aaletivo: this.aaletivo});

        this.optionsTurma = data.results.map(key => ({ text: `${key.nmturma} - ${key.horario}`, value: key.cdturma }));
        this.optionsTurma.unshift(defaultSelect());

      } finally {
        this.loading = false;
      }
    },

    async gerarRelatorio() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      this.loadingGerar = true;
      try {
        const { data } = await ProfessorReportsRepository.getAulasMinistradasExigidas({
          aaletivo: this.aaletivo,
          cdtipesc: this.cdtipesc,
          cdescola: this.cdescola,
          cdpessoal: this.cdpessoal,
          cdmatric: this.cdmatric,

        });
        const filtros = {
            aaletivo: this.aaletivo,
            cdtipesc: this.cdtipesc,
            cdescola: this.cdescola,
            cdpessoal: this.cdpessoal,
            cdmatric: this.cdmatric,
            nmescola: this.school.nmescola,
            professores: data.results.professores,
            identificadorperfil: this.userDadosPerfilAtual.identificadorperfil,
        };

        const docDefinition = await aulasMinistradasExigidasReport({
          date: data.results.date,
          time: data.results.time,
          filtros,
          data: data.results.aulasexigidas,
          professores: data.results.professores,
          indicaanoletivoexcedeu: data.results.configuracao_ano_letivo.indicaanoletivoexcedeu,
          anoSubsequente: data.results.configuracao_ano_letivo.fim.substring(0,4), // 2021
        });

        pdfMake.createPdf(docDefinition).download(docDefinition.info.title);
      } finally {
        this.loadingGerar = false;
      }
    },
  },
  computed: {
    ...mapGetters(['getAnoSistema', 'getAnoAtualServidor', 'getAnoInicioSistema', 'userProfessor', 'school', 'username', 'userDadosPerfilAtual']),
    optionsAno() {
      if(!this.getAnoInicioSistema || !this.getAnoAtualServidor) { return []; }
      let retornoOptions = [defaultSelect()];
      for(let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
  },
}
</script>

<style>

</style>
